package example.mystybag.db

import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import example.mystybag.db.database.newInstance
import example.mystybag.db.database.schema
import kotlin.Unit
import mobile.icard.ICardRoomDatabase.ContactImageLinksQueries
import mobile.icard.ICardRoomDatabase.EmbeddingsQueries

public interface MystyBagRoomDatabase : Transacter {
  public val contactImageLinksQueries: ContactImageLinksQueries

  public val embeddingsQueries: EmbeddingsQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.Value<Unit>>
      get() = MystyBagRoomDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): MystyBagRoomDatabase =
        MystyBagRoomDatabase::class.newInstance(driver)
  }
}
